/**
 * @file CustomerSourceFields.tsx
 * @description Поля «Источник привлечения» формы клиента (phase19.31 —
 * вынесено из `CustomerEditDialog`, нативный список заменён общим
 * `SelectField`): канал и метка рекламы ERID (ФЗ-38).
 *
 * Контракт `value/onChange` — как у секций формы перевозчика: форма держит
 * состояние, блок только рисует поля.
 */

import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { SelectField, type SelectFieldOption } from "../ui/SelectField";
import { Separator } from "../ui/separator";

export interface CustomerSourceValue {
  acquisitionSource: string;
  acquisitionErid: string;
}

interface Props {
  value: CustomerSourceValue;
  onChange: (patch: Partial<CustomerSourceValue>) => void;
}

/** Источник привлечения: пустое значение — «не указан». */
const SOURCE_OPTIONS: SelectFieldOption[] = [
  { value: "", label: "Не указан" },
  { value: "DIRECT", label: "Прямой переход" },
  { value: "ORGANIC", label: "Поисковая выдача" },
  { value: "PAID", label: "Платная реклама" },
  { value: "SOCIAL", label: "Соцсети" },
  { value: "REFERRAL", label: "Реферал" },
  { value: "UTM_OTHER", label: "Иное (UTM)" },
];

/** Источник, которого нет в списке (пришёл из импорта), остаётся выбранным своим словом. */
function customerSourceOptions(current: string): SelectFieldOption[] {
  return current && !SOURCE_OPTIONS.some((o) => o.value === current)
    ? [...SOURCE_OPTIONS, { value: current, label: current }]
    : SOURCE_OPTIONS;
}

export function CustomerSourceFields({ value, onChange }: Props) {
  return (
    <>
      <Separator className="my-2" />
      <p className="type-card-title text-on-surface">Источник привлечения (необязательно)</p>
      <div className="flex flex-col gap-1.5">
        <Label htmlFor="c-src">Источник</Label>
        <SelectField
          id="c-src"
          ariaLabel="Источник привлечения"
          value={value.acquisitionSource}
          onChange={(acquisitionSource) => onChange({ acquisitionSource })}
          options={customerSourceOptions(value.acquisitionSource)}
        />
      </div>
      <div className="flex flex-col gap-1.5">
        <Label htmlFor="c-erid">ERID-токен (ФЗ-38)</Label>
        <Input
          id="c-erid"
          value={value.acquisitionErid}
          onChange={(e) => onChange({ acquisitionErid: e.target.value })}
        />
        <p className="type-caption text-on-surface-variant">Если клиент пришёл по платной рекламе с ERID</p>
      </div>
    </>
  );
}
